<div
  class="user-profile-hover-screen"
  [ngClass]="[userprofile$ | async]"
  (click)="toggleMenu()"
></div>

<div class="user-profile p-4">
  <div class="d-flex">
    <mat-icon class="ms-auto button" (click)="toggleMenu()">close </mat-icon>
  </div>

  <div class="mt-3 user-profile-test-data">
    <div class="row">
      <div class="col-6 menu-icon-wrapper" (click)="onClick(routeNames.impressum)">
        <mat-icon>info</mat-icon>
        <span>Impressum</span>
      </div>
      <div class="col-6 menu-icon-wrapper" (click)="onClick(routeNames.datenschutz)">
        <mat-icon>verified_user</mat-icon>
        <span>Datenschutz</span>
      </div>
    </div>

    <prp-user-profile-editor [profile]="profile"></prp-user-profile-editor>

    <ng-scrollbar *ngIf="previewProfile" class="mt-2">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Profile </mat-panel-title>
          </mat-expansion-panel-header>

          <code>{{ profile | json }}</code>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Profile local storage </mat-panel-title>
          </mat-expansion-panel-header>

          <code>{{ profileLocal | json }}</code>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Roles </mat-panel-title>
          </mat-expansion-panel-header>

          <code>{{ roles | async | json }}</code>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-scrollbar>
  </div>
</div>
